'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (action) {
  return !!(action.meta && action.meta.location && action.meta.location.current);
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-first-router/dist/pure-utils/isLocationAction.js
// module id = 383
// module chunks = 2